document.addEventListener('DOMContentLoaded', function () {
  const form = document.querySelector('[name="executor_subordinates_search"]');
  if (form) {
    const orderNameSelect = document.querySelector('.order-executor-select');
    const orderRoleSelect = document.querySelector(
      '[name="executor_subordinates_search[role]"]'
    );

    let orderOffset = document.getElementById(
      'executor_subordinates_search_offset'
    );

    orderNameSelect.addEventListener('change', function () {
      removeParam('admin_subordinates_search[offset]');
      orderOffset.value = 0;
      orderNameSelect.form.submit();
    });

    orderRoleSelect.addEventListener('change', function () {
      removeParam('admin_subordinates_search[offset]');
      orderOffset.value = 0;
      orderRoleSelect.form.submit();
    });
  }
});
